import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

// Custom Eye SVG Icon
export const EyeIcon = ({ color = '#BFBFBF', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Outer eye shape */}
    <path
      d="M32 12C19 12 8.3 22 4 32c4.3 10 15 20 28 20s23.7-10 28-20c-4.3-10-15-20-28-20z"
      fill="none"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Iris ring */}
    <circle cx="32" cy="32" r="10" fill={color} />
    {/* Inner white pupil */}
    <circle cx="32" cy="32" r="3" fill="white" />
  </svg>
);

// Styles
const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: "center",
  },
  eyeButton: {
    padding: 4,
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
};



const EyeFieldBase = ({ enabled, onClick, classes }) => (
  <div className={classes.root}>
    <IconButton
      className={classes.eyeButton}
      onClick={enabled ? onClick : undefined}
      disabled={!enabled}
      disableRipple
    >
      <EyeIcon color={enabled ? '#ECA33C' : '#BFBFBF'} size={24} />
    </IconButton>
  </div>
);

export const EyeField = withStyles(styles)(EyeFieldBase);
